export const BM_STINGER_REPO_LIST_SCOPES = [
  'is-admin',
  'bm-stinger-repo:list',
  'base-message-repository:list',
];

export const BM_STINGER_REPO_CREATE_SCOPES = [
  'is-admin',
  'bm-stinger-repo:create',
  'base-message-repository:create',
];

export const BM_STINGER_REPO_VIEW_SCOPES = [
  'is-admin',
  'bm-stinger-repo:view',
  'base-message-repository:update',
];

export const BM_STINGER_REPO_EDIT_SCOPES = [
  'is-admin',
  'bm-stinger-repo:edit',
  'base-message-repository:update',
];

export const BM_STINGER_REPO_DELETE_SCOPES = [
  'is-admin',
  'bm-stinger-repo:delete',
  'base-message-repository:delete',
];

export const BM_STINGER_REPO_MENU_SCOPES = Array.from(
  new Set([
    ...BM_STINGER_REPO_LIST_SCOPES,
    ...BM_STINGER_REPO_CREATE_SCOPES,
    ...BM_STINGER_REPO_VIEW_SCOPES,
    ...BM_STINGER_REPO_EDIT_SCOPES,
    ...BM_STINGER_REPO_DELETE_SCOPES,
  ]),
);

export const bmStingerRepoListScope = BM_STINGER_REPO_LIST_SCOPES.join(',');
export const bmStingerRepoCreateScope = BM_STINGER_REPO_CREATE_SCOPES.join(',');
export const bmStingerRepoViewScope = BM_STINGER_REPO_VIEW_SCOPES.join(',');
export const bmStingerRepoEditScope = BM_STINGER_REPO_EDIT_SCOPES.join(',');
export const bmStingerRepoDeleteScope = BM_STINGER_REPO_DELETE_SCOPES.join(',');
